module.exports = __webpack_public_path__ + "static/media/aws_logo.6c9f5d7a.png";